import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";

const Error500 = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f8f9fa",
      }}
    >
      <Container className="text-center">
        <h1
          style={{
            fontSize: "72px",
            fontWeight: "600",
            marginBottom: "10px",
          }}
        >
          404
        </h1>

        <p
          style={{
            fontSize: "18px",
            color: "#6c757d",
            marginBottom: "30px",
          }}
        >
          Page not found.
        </p>

        <Link
          to="/dashboard"
          className="btn btn-primary px-4"
        >
          Back to Dashboard
        </Link>
      </Container>
    </div>
  );
};

export default Error500;
